import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { browserHistory } from 'react-router';
import * as d3 from 'd3';

import withStyles from '../../decorators/withStyles';
import ZillowData from '../ZillowData';
import Zillow from '../Zillow';
// import ZillowPlaceType from '../ZillowPlaceType';
// import ZillowRanking from '../ZillowRanking';
import styles from './ZillowEmbed.css';


const ZillowSlide = ({ elevMeta, place, placeID, placeType, zillowIsPct, zillowModel,
                       zillowPathway, zillowPlaceType, zillowPlaceTypeOptions,
                       zillowProb, zillowVarType, zillowYear, zillowYrBuilt }) => {
  return (
    <ZillowData
      place={place}
      zillowModel={zillowModel}
      zillowPathway={zillowPathway}
      zillowProb={zillowProb}
    >
      <Zillow
        elevMeta={elevMeta}
        isEmbed={true}
        placeID={placeID}
        placeType={placeType}
        zillowIsPct={zillowIsPct}
        zillowModel={zillowModel}
        zillowPathway={zillowPathway}
        zillowPlaceType={zillowPlaceType}
        zillowPlaceTypeOptions={zillowPlaceTypeOptions}
        zillowProb={zillowProb}
        zillowVarType={zillowVarType}
        zillowYear={zillowYear}
        zillowYrBuilt={zillowYrBuilt}
      />
    </ZillowData>
  );
};


class ZillowEmbed extends Component {

  render() {
    return (
      <div className="ZillowEmbed band white embedded">
        <section>
          <ZillowSlide />
        </section>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(ZillowEmbed);
